import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { inputFieldProps } from './input-field.props';
import { DynamicStatusTag } from '../../modules/super-admin/dashboard/data/constant';

function InputField({
  label,
  type = 'text',
  placeholder,
  name,
  value,
  handleChange,
  handleClick,
  className,
  error,
  tooltip,
  maxLength,
  disabled = false, // Handles read-only states
  profileInputStyle = false, // Toggle for ProfileInput design
  editable = true, // Default to true if not provided
  isRequired = true,
  min,
  chipsEnabled,
  labelSize = 'sm',
}: inputFieldProps) {
  // Tooltip rendering function
  const renderTooltip = (props: object) => (
    <Tooltip
      id="button-tooltip"
      className="text-slate-500 text-xs bg-white p-2 rounded-lg"
      {...props}
    >
      {tooltip}
    </Tooltip>
  );

  // Conditional class for the input based on the `profileInputStyle` prop
  const inputClass = profileInputStyle
    ? `border-1 border-solid py-[10px] text-[16px] text-[#0A1116] font-medium px-[16px] rounded-lg ${
        disabled || !editable ? 'bg-[#E4E4E74D]' : 'bg-white'
      }  ${labelSize === 'xs' ? 'text-xs' : 'text-md'}  border-[#E4E4E7] w-full`
    : `px-[13px] py-[11px] text-[12px] font-normal text-[#000] rounded-lg ${
        error ? 'border-red-400 focus:border-red-400' : 'border-gray-300'
      }`;

  return (
    <div className={`mb-0 flex flex-col mx-0 justify-between ${className ? ` ${className}` : ''}`}>
      {label && (
        <div className="flex ">
          <span
            className={
              profileInputStyle
                ? `${labelSize === 'xs' ? 'text-xs' : 'text-sm'} font-medium text-[#6A6A6A] mb-1`
                : 'mb-0 mt-2 text-[.6875rem] text-black font-bold'
            }
          >
            {label}
            {chipsEnabled && (
              <span className="ml-1 text-sm">{DynamicStatusTag({ status: chipsEnabled })}</span>
            )}
            {isRequired && (
              <sup className="text-[#ef4444] text-[larger]  leading-0 top-[0.1rem]">
                {` `}*
                {tooltip && (
                  <OverlayTrigger
                    key="top"
                    placement="right"
                    overlay={renderTooltip}
                    delay={{ show: 250, hide: 400 }}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      strokeWidth={1.5}
                      stroke="#9B9B9B"
                      className="w-4 cursor-pointer inline info-icon mb-1 ms-[8px]"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M11.25 11.25l.041-.02a.75.75 0 011.063.852l-.708 2.836a.75.75 0 001.063.853l.041-.021M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-9-3.75h.008v.008H12V8.25z"
                      />
                    </svg>
                  </OverlayTrigger>
                )}
              </sup>
            )}
          </span>
        </div>
      )}
      <input
        type={type}
        name={name}
        value={value}
        className={inputClass}
        placeholder={placeholder?.toString() || ''}
        onChange={editable ? handleChange : undefined}
        onClick={editable ? handleClick : undefined}
        maxLength={maxLength}
        min={min}
        disabled={disabled || !editable}
      />
      {error && <div className="block text-[red] text-xs font-normal mt-[2px] ">{error}</div>}
    </div>
  );
}

export default InputField;
